import { ref } from "vue"
import ComponentesService from "@/services/ComponentesService"
import EstadoPneusConstant from "@/constants/EstadoPneusConstant";
import StatusComponenteConstant from "@/constants/StatusComponenteConstant";

class ComponenteEstadoPneuService {
    setup({ respostas, respostaObrigatoria, etapaComponente, identificador, modulo, resumoModulos }) {
        const estadosValoresEnum = EstadoPneusConstant.ESTADOS;
        const estadosPneus = ref(respostas || EstadoPneusConstant.TIPOS);
        const statusResposta = ref(StatusComponenteConstant.NAO_PREENCHIDO.chave);
    
        if (!resumoModulos) {
            if (respostas) {
                statusResposta.value = ComponentesService.validaStatusRespostaComponente(respostaObrigatoria, true);
            } else {
                ComponentesService.salvarRespostaEstadoComponente(modulo, etapaComponente, identificador, estadosPneus.value);
            }
            ComponentesService.salvarStatusComponente(etapaComponente, identificador, modulo, statusResposta.value);
        }
    
        return { estadosPneus, estadosValoresEnum, statusResposta };
    }
}

export default new ComponenteEstadoPneuService();